export const dpr = (url: string, hasZoomedIn: boolean = false) => {
    if (url.includes('.svg')) {
        return url.split('?')[0];
    }

    return `${url}${url.includes('?') ? '&' : '?'}dpr=${
        hasZoomedIn ? '3' : '1.5'
    } 1x, ${url}${url.includes('?') ? '&' : '?'}dpr=${
        hasZoomedIn ? '4' : '2'
    } 2x`;
};
